import { render, staticRenderFns } from "./StudentActivitiesDoneInRealtime.vue?vue&type=template&id=0054952f&scoped=true"
import script from "./StudentActivitiesDoneInRealtime.vue?vue&type=script&lang=js"
export * from "./StudentActivitiesDoneInRealtime.vue?vue&type=script&lang=js"
import style0 from "./StudentActivitiesDoneInRealtime.vue?vue&type=style&index=0&id=0054952f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054952f",
  null
  
)

export default component.exports